export const theme = {
  colors: {
    text: {},
  },

  fonts: {
    text: "Open Sans, sans-serif",
    main: "Roboto, sans-serif",
    pretitle: "Yellowtail, cursive",
  },
};
